// Firestore collection name for portfolio items
export const PORTFOLIO_COLLECTION = 'portfolioItems';
